import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { CustomItemCategoryBlocksComponentData } from './custom-item-category-blocks-component.model';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
  selector: 'app-custom-item-category-blocks-component',
  templateUrl: './custom-item-category-blocks-component.html',
  styleUrls: ['./custom-item-category-blocks-component.scss'],
  standalone: false
})
export class CustomItemCategoryBlocksComponent implements OnInit {
  @Input() item: CustomItemCategoryBlocksComponentData;
  @HostBinding('class') styleClasses: string;

  constructor(public component: CmsComponentData<CustomItemCategoryBlocksComponentData>) { }

  ngOnInit(): void {
  }
}
